// The reports moving off Tableau and the FleetioDB2 SQL Server, read live through
// the fleet reports API (backend/src/routes/fleetReports.js).
import ReportRunner from '../components/Reports/ReportRunner';

export default function FleetReports() {
  return (
    <ReportRunner
      basePath="/fleet-reports"
      eyebrow="Fleet"
      title="Fleet Reports"
      subtitle="From Fleetio, updated hourly."
      filePrefix="fleet"
    />
  );
}
